import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DGCoinDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchDGCoinPlans } from "../../../../features/auth/store/dgcoinPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import DGCoin from "./DGCoin";
import { fetchDGCoinCategories } from "../../../../features/auth/store/dgcoinCategorySlice";
import { fetchCountries } from "../../../../features/auth/store/countrySlice";
import { SortBy, SortOrder } from "../../../../features/auth/store/types/types";

const DGCoinRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [categoryFilter, setCategoryFilter] = useState<string>("");
  const [countryFilter, setCountryFilter] = useState<string>("");
  const [sortBy, setSortBy] = useState<SortBy | "">("created_at");
  const [sortOrder, setSortOrder] = useState<SortOrder | "">("desc");
  const [selectedDGCoinPlan, setSelectedDGCoinPlan] = useState<Product | null>(
    null,
  );
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { dgcoinPlans, loading, error } = useSelector(
    (state: RootState) => state.dgcoinPlans,
  );

  const { dgcoinCategories } = useSelector(
    (state: RootState) => state.dgcoinCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (!dgcoinCategories || dgcoinCategories.length == 0) {
      dispatch(fetchDGCoinCategories({ perPage: 100 }));
    }
    dispatch(fetchCountries({ page: 1, perPage: 100 }));
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchDGCoinPlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (categoryFilter) filters.category = categoryFilter; // ID sent
      if (countryFilter) filters.country = countryFilter; // ID sent
      if (sortBy) filters.sort_by = sortBy;
      if (sortOrder) filters.sort_order = sortOrder;
      if (searchTerm.trim()) filters.search = searchTerm.trim();

      dispatch(fetchDGCoinPlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [
    dispatch,
    statusFilter,
    categoryFilter,
    countryFilter,
    sortBy,
    sortOrder,
    searchTerm,
  ]);

  const handleDGCoinPlanClick = (dgcoinPlan: Product) => {
    setSelectedDGCoinPlan(dgcoinPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedDGCoinPlan(null);
  };

  if (showDetailView && selectedDGCoinPlan) {
    return (
      <DGCoinDetailView
        dgcoinPlan={{
          ...selectedDGCoinPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <DGCoin
      dgcoinPlans={dgcoinPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onDGCoinPlanClick={handleDGCoinPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      categoryFilter={categoryFilter}
      setCategoryFilter={setCategoryFilter}
      countryFilter={countryFilter}
      setCountryFilter={setCountryFilter}
      sortBy={sortBy}
      setSortBy={setSortBy}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
    />
  );
};

export default DGCoinRouter;
